import useSWR from 'swr';
import { httpResponseToJSON } from '../helpers/fetchHelpers';
import { getAuthenticatedHeaders } from './fetchHeaders';
import { logFailedRequestTiming, logRequestTiming } from './insightsHelper';

export const useTechAssistAddStarterData = (serialNumber) => {
    const url = `/api/v1/techassist/serial/add?serialNumber=${serialNumber}`;
    const startTime = performance.now(); // Start timing
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        !!serialNumber ? url : null,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(url, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading engine info'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, _key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming('/api/v1/techassist/serial/add?serialNumber=${serialNumber}', Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isLoading, isValidating, mutate };
};


export const useTechAssistSerialDetails = (serialNumber) => {
    const url = `/api/v1/techassist/serial/details?serialNumber=${serialNumber}`;
    const startTime = performance.now(); // Start timing
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        !!serialNumber ? url : null,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(url, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading engine info'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, _key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming('/api/v1/techassist/serial/details?serialNumber=${serialNumber}', Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isLoading, isValidating, mutate };
};


export const useTechAssistCallsForDealer = (serialNumber) => {
    const url = `/api/v1/techassist/list?serialNumber=${serialNumber || ''}`;
    const startTime = performance.now(); // Start timing
    const { data, error, isLoading, isValidating, mutate } = useSWR(
        url,
        () => getAuthenticatedHeaders().then((headers) => {
            return fetch(url, { headers })
                .then(response => httpResponseToJSON(response, 'Error loading call info'/*, showError*/))
        }),
        {
            ...swrConfig,
            onSuccess: (_data, _key) => {
                const endTime = performance.now(); // End timing
                logRequestTiming(`/api/v1/techassist/list?serialNumber=${serialNumber}`, Math.round(endTime - startTime));
            },
            onError: (_error, key) => {
                const endTime = performance.now(); // End timing
                logFailedRequestTiming(key, Math.round(endTime - startTime));
            }
        });

    return { data, error, isLoading, isValidating, mutate };
};

const swrConfig = {
    revalidateOnFocus: false,
    onErrorRetry: (error, _key, _config, revalidate, { retryCount }) => {
        // Never retry on 4XX error.
        if (error.status >= 400 && error.status < 500) return;

        //   // Never retry for a specific key.
        //   if (key === '/api/user') return

        // Only retry up to 1 times.
        if (retryCount > 1) return;

        // Retry after 1 seconds.
        setTimeout(() => { revalidate({ retryCount }); }, 1000)
    }
};